import { Component, OnInit } from '@angular/core';
import {OrgaoJulgadorLocal} from '../orgao-julgador-local.model';
import {ActivatedRoute} from '@angular/router';
import {MensagemService, ProgressoService} from 'maestro-ng';
import {OrgaoJulgadorLocalService} from '../orgao-julgador-local.service';
import {SelectItemService} from '../../services/select-item.service';
import {SelectItem} from 'primeng/api';

@Component({
  selector: 'app-orgao-julgador-local-visualizacao',
  templateUrl: './orgao-julgador-local-visualizacao.component.html',
  styleUrls: ['./orgao-julgador-local-visualizacao.component.css']
})
export class OrgaoJulgadorLocalVisualizacaoComponent implements OnInit {
  public orgaoJulgadorLocal: OrgaoJulgadorLocal;
  public instanciaItens: SelectItem[];

  constructor(
    private route: ActivatedRoute,
    private progressoService: ProgressoService,
    private mensagemService: MensagemService,
    private orgaoJulgadorLocalService: OrgaoJulgadorLocalService,
    private selectItemService: SelectItemService,
  ) { }

  ngOnInit(): void {
    this.orgaoJulgadorLocal = {} as OrgaoJulgadorLocal;
    this.route.params.subscribe(params => {
      if (params['id']) {
        this.progressoService.modal();
        this.orgaoJulgadorLocalService.recuperarPorId(+params['id'])
          .then((orgaoJulgadorLocal: OrgaoJulgadorLocal) => this.carregarorgaoJulgadorLocal(orgaoJulgadorLocal))
          .catch(response => this.mensagemService.addErro('Erro ao carregar o órgao julgador local.', response.error));
      }
      this.instanciaItens = this.selectItemService.getInstanciaItens();
    });
  }
  public carregarorgaoJulgadorLocal(orgaoJulgadorLocal: OrgaoJulgadorLocal): void {
    this.orgaoJulgadorLocal = orgaoJulgadorLocal;
    this.progressoService.fechar();
  }
}
